import { ref } from 'vue';

export function createKanbanDashboardController({ loadKanbanDashboard, refreshIntervalMs }) {
  const rowData = ref([]);
  const searchText = ref('');
  const statusFilter = ref('');
  const ultimaAtualizacao = ref('');
  const isLoading = ref(false);
  const errorMessage = ref('');
  const gridApi = ref(null);
  const pageSize = ref(100);
  let intervalId = null;

  const onGridReady = (params) => {
    gridApi.value = params.api;
  };

  const exportToCsv = () => {
    if (!gridApi.value) {
      return;
    }

    gridApi.value.exportDataAsCsv({
      fileName: `kanban_sce_${Date.now()}.csv`,
      columnSeparator: ';',
    });
  };

  const load = async () => {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    errorMessage.value = '';

    try {
      const data = await loadKanbanDashboard.execute({
        page: 1,
        limit: 1000000,
        status: statusFilter.value,
        search: searchText.value,
      });

      rowData.value = data.items;

      const now = new Date();
      ultimaAtualizacao.value = `${now.toLocaleDateString('pt-BR')} ${now.toLocaleTimeString('pt-BR')}`;
    } catch (error) {
      errorMessage.value = 'Nao foi possivel sincronizar o kanban.';
    } finally {
      isLoading.value = false;
    }
  };

  const applyFilters = async () => {
    await load();
  };

  const updatePageSize = (value) => {
    pageSize.value = Number(value);
  };

  const start = async () => {
    await load();
    intervalId = setInterval(load, refreshIntervalMs);
  };

  const stop = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  return {
    rowData,
    searchText,
    statusFilter,
    ultimaAtualizacao,
    isLoading,
    errorMessage,
    pageSize,
    onGridReady,
    exportToCsv,
    load,
    applyFilters,
    updatePageSize,
    start,
    stop,
  };
}
